import { Box, Checkbox, CircularProgress, FormControl, InputLabel, List, ListItem, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import APIManager from '../../lib/apiManager';
import { sistema } from "../../model/Sistema";
import moment from "moment";
import Ubicaciones from "./components/Ubicaciones";
import DescripcionCard from "./components/DescripcionCard";
import Confirmacion from "./components/Confirmacion";

const Reservas = ({ setBotonera, espacio, espacios }) => {

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('company');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState([]);

  const [active, setActive] = useState(sistema?.dataDeBusqueda?.active ?? true);
  const [textoDeBusqueda, setTextoDeBusqueda] = useState(sistema?.dataDeBusqueda?.textoDeBusqueda ?? '');
  const [fechaDesde, setFechaDesde] = useState(new Date().toISOString().substring(0, 10));
  const [fechaHasta, setFechaHasta] = useState(new Date().toISOString().substring(0, 10));

  const [espaciosDisponibles, setEspaciosDisponibles] = useState(espacios);
  const [espacioSeleccionado, setEspacioSeleccionado] = useState(espacio);

  const [reservasCancelables, setReservasCancelables] = useState([]);
  const [reservasACancelar, setReservasACancelar] = useState([]);

  const [cambioEnFiltros, setCambioEnFiltros] = useState(false);
  const [nuevo, setNuevo] = useState(false);
  const [loading, setLoading] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);

  const navigate = useNavigate();

  const espacioColumn = {
    id: 'espacioNombre',
    numeric: false,
    disablePadding: false,
    label: 'Espacio',
  };

  const basicColumns = [{
    id: 'fecha',
    numeric: false,
    disablePadding: false,
    label: 'Fecha',
  },
  {
    id: 'descripcionStr',
    numeric: false,
    disablePadding: true,
    label: 'Descripción',
  },
  {
    id: 'ubicaciones',
    numeric: false,
    disablePadding: true,
    label: 'Reservas',
  },
  ];
  const [columns, setColumns] = useState(basicColumns);

  const isSelected = (name) => selected.indexOf(name) !== -1;

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const openItem = (event, id) => {
    navigate('/reservas/' + id);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const handleClose = () => {
    setOpenDialog(false);
  }

  const handleConfirmar = () => {
    cancelarReservas(handleClose);
  }

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const actualizarItems = () => {
    const filtros = { fechaDesde: fechaDesde, fechaHasta: fechaHasta, espacioSeleccionado: espacioSeleccionado };
    sistema.actual.filtros = !!sistema?.actual?.filtros ? { ...sistema.actual.filtros, ...filtros } : filtros;
    sistema.saveActual();
    setLoading(true);
    setRows([]);
    setReservasACancelar([]);
    setReservasCancelables([]);
    sistema.dataDeBusqueda = { textoDeBusqueda, active };
    let postData = {
      orderBy: 'fecha desc, tipo',
      paraAcceso: true,
      nombre: textoDeBusqueda,
      espacioID: espacioSeleccionado?.id ?? null,
    }
    if (!!fechaDesde) {
      postData.fechaDesde = fechaDesde;
    }
    if (!!fechaHasta) {
      postData.fechaHasta = fechaHasta;
    }
    APIManager.getList('reservasDelDia', postData, (response) => {
      if (response.success) {
        if (response.data.listado.length > 0) {
          if (!espacioSeleccionado) {
            setColumns([espacioColumn, ...basicColumns])
          } else {
            setColumns(basicColumns);
          }
        }
        const listado = response.data.listado.map(item => {
          // item.fecha = moment(item.fecha).format('L');
          item.ubicaciones = Object.values(item.ubicaciones);
          item.ubicaciones.map(element => {
            element.usuario = item.usuario;
            element.asistencia = element.checked;
            element.cancelacionID = element.reserva_tipo + element.reserva_id;
            element.checked = false;
            element.espacio = item.espacio;
            if (!element.fecha) {
              element.fecha = item.fecha;
            }
            if (!!item.empresa) {
              element.empresa = item.empresa; return element
            }
          });
          item.espacioNombre = item.espacio?.nombre;
          item.imagen = item.empresa?.imagen || item.usuario?.imagen;
          item.asistencia = item.checked;
          item.checked = false;
          return item;
        });
        sistema.actual.listado = listado;
        setRows(listado);
        setReservasCancelables(getReservasCancelables(listado));
        setCambioEnFiltros(false);
        setLoading(false);
      }
    })
  }

  const getReservasCancelables = (listado) => {
    const reservas = [];
    listado.forEach(row => {
      row.ubicaciones.forEach(ubi => {
        if (!!ubi.cancelable) {
          reservas.push(ubi);
        }
      });
    });
    return reservas;
  }

  const toggleActive = (event) => {
    setActive(!active);
  }

  const handleChangeTextoDeBusqueda = (event) => {
    setTextoDeBusqueda(event.target.value);
    setCambioEnFiltros(true);
  }

  const handleFechaDesde = (event) => {
    setFechaDesde(event.target.value);
    setCambioEnFiltros(true);
  }

  const handleFechaHasta = (event) => {
    setFechaHasta(event.target.value);
    setCambioEnFiltros(true);
  }

  const handleChangeEspacio = (event) => {
    setEspacioSeleccionado(event.target.value);
    setCambioEnFiltros(true);
  }

  const handleChangeActive = event => {
    setActive(event.target.checked);
    setCambioEnFiltros(true);
  }

  const handleTextoDeBusquedaKeyup = (event) => {
    if (event.code === 'Enter') {
      actualizarItems();
    }
  }

  const handleAsistenciaClick = (item, ubicacion) => {
    // Hicieron click para marcar asistencia en una ubicacion
    console.log('Asistencia: ',item, ubicacion);
  }

  const handleCheck = (item, ubicacion) => {
    // Hicieron click para marcar asistencia en una ubicacion
    ubicacion.checked = !ubicacion.checked;
    if (!ubicacion.checked) {
      setReservasACancelar(reservasACancelar.filter(reserva => reserva.cancelacionID !== ubicacion.cancelacionID));
    } else {
      setReservasACancelar([...reservasACancelar, ubicacion]);
    }
    setRows(rows.map(row => {
      if (row.id === item.id) {
        row.ubicaciones = row.ubicaciones.map(ubi => {
          if ((ubi.reserva_id == ubicacion.reserva_id) && (ubi.reserva_tipo == ubicacion.reserva_tipo)) {
            if (!ubi.asistencia) {
              ubi.checked = ubicacion.checked;
            }
          }
          return ubi;
        })
      }
      return row;
    }))
  }

  const setAllRowsACancelar = (cancelar) => {
      setRows(rows.map(row => {
        row.ubicaciones = row.ubicaciones.map(ubi => {
          if (!!ubi.cancelable) {
            ubi.checked = cancelar;
          }
          return ubi;
        });
        return row;
      }));
  }

  const handleCancelarTodasClick = (event) => {
    if (reservasACancelar.length < reservasCancelables.length) {
      setReservasACancelar(reservasCancelables);
      setAllRowsACancelar(true);
    } else {
      setReservasACancelar([]);
      setAllRowsACancelar(false);
    }
  }

  const handleCancelarReservas = (event) => {
    setOpenDialog(true);
  }

  const cancelarReservas = (callback) => {
    const reservas = reservasACancelar.map(res => {return {subtipo: res.reserva_tipo, id: res.reserva_id}});
    APIManager.sendRequest('post', 'reservas', 'cancelarReservas', {reservas: reservas}, response => {
      if (response.success) {
        actualizarItems();
        if (!!callback) {
          callback();
        }
      }
    })
  }

  useEffect(() => {
    sistema.actual.active = active;
    sistema.actual.reservasACancelar = reservasACancelar;
    setBotonera([
      { type: 'input', id: 'input-texto', inputType: 'text', title: 'Descripción', label: 'Descripción', value: textoDeBusqueda, onChange: handleChangeTextoDeBusqueda, onKeyUp: handleTextoDeBusquedaKeyup },
      // { type: 'input', inputType: 'checkbox', title: 'Mostrar solo Beneficios activos', label: 'Solo activos',  checked: active, onChange: handleChangeActive },
      // { type: 'input', id: 'input-fechaDesde', inputType: 'date', title: 'Fecha desde', label: 'Fecha desde', value: fechaDesde, onChange: handleFechaDesde },
      { type: 'text', id: 'input-fechaDesde', inputType: 'date', variant: 'standard', title: 'Fecha desde', label: 'Fecha desde', InputLabelProps: { shrink: true }, value: fechaDesde, onChange: handleFechaDesde },
      // { type: 'input', id: 'input-fechaHasta', inputType: 'date', title: 'Fecha hasta', label: 'Fecha hasta', value: fechaHasta, onChange: handleFechaHasta },
      { type: 'text', id: 'input-fechaHasta', inputType: 'date', variant: 'standard', title: 'Fecha hasta', label: 'Fecha hasta', InputLabelProps: { shrink: true }, value: fechaHasta, onChange: handleFechaHasta },
      {
        type: 'select', id: 'select-espacio', control:
          <FormControl sx={{minWidth: 150}}>
            <InputLabel id="espacio-label">Espacio</InputLabel>
            <Select
              labelId="espacio-label"
              value={espacioSeleccionado}
              label="Espacio"
              disabled={espaciosDisponibles.length < 2}
              onChange={handleChangeEspacio}
            >
              <MenuItem value=''>Todos</MenuItem>
              {espaciosDisponibles.map(item => <MenuItem value={item}>{item.nombre}</MenuItem>)}
            </Select>
          </FormControl>
        , title: 'Espacio', label: 'Espacio', value: espacioSeleccionado, onChange: handleChangeEspacio
      },
      { title: 'Buscar', label: 'Buscar', variant: (cambioEnFiltros ? 'contained' : 'outlined'), onClick: () => { actualizarItems() } },
      { title: 'Nueva', label: 'Nueva', variant: 'outlined', onClick: (event) => { openItem(event, 'nuevo'); setNuevo(!nuevo) } },
      { title: 'Cancelar reservas', label: 'Cancelar reservas', variant: (reservasACancelar.length > 0 ? 'contained' : 'outlined'), onClick: handleCancelarReservas, disabled: (reservasACancelar.length == 0) },
    ]);
  }, [active, textoDeBusqueda, fechaDesde, fechaHasta, espacioSeleccionado, cambioEnFiltros, nuevo, espaciosDisponibles, reservasACancelar]);

  // useEffect(() => {
  //   setEspacioSeleccionado(espacio);
  //   setCambioEnFiltros(true);
  // }, [espacio]);

  useEffect(() => {
    if (espaciosDisponibles.length > 0) {
      const espacioElegido = espaciosDisponibles.find(item => item.id == espacioSeleccionado.id);
      if (espacioElegido !== espacioSeleccionado) {
        setEspacioSeleccionado(espacioElegido);
      }

    }
  }, [espaciosDisponibles]);

  useEffect(() => {
    // Cargamos los espacios
    APIManager.getList('espacios', { orderBy: 'nombre', active: true }, (response) => {
      if (response.success) {
        setEspaciosDisponibles(response.data.listado);
      }
    });

  }, [])

  return (
    <Box>
      <Paper sx={{ width: '100%', mb: 2 }}>
        {!!openDialog && <Confirmacion open={openDialog} onClose={handleClose} onConfirm={handleConfirmar}
                reservas={reservasACancelar} />}
        <Typography padding={2} fontWeight="bold" fontSize="large">Lista de Reservas</Typography>
        <TableContainer sx={{maxHeight: 'calc(100vh - 64px - 64px - 85px - 32px - 60px)'}}>
          <Table
            sx={{ minWidth: 750 }}
            stickyHeader
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <TableHead>
              <TableRow>
                {/* <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={selected.length > 0 && selected.length < rows.length}
                    checked={rows.length > 0 && selected.length === rows.length}
                    onChange={handleSelectAllClick}
                    inputProps={{
                      'aria-label': 'select all desserts',
                    }}
                  />
                </TableCell> */}
                {columns.map((headCell, idx) => (
                  <TableCell
                    key={headCell.id}
                    align={headCell.numeric ? 'right' : 'left'}
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={createSortHandler(headCell.id)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                    {/* {(idx === columns.length-1)
                      ? <Checkbox
                        color="primary"
                        sx={{position: 'absolute', right: '5px', top: '7px'}}
                        indeterminate={reservasACancelar.length > 0 && reservasACancelar.length < reservasCancelables.length}
                        checked={reservasACancelar.length > 0 && reservasACancelar.length === reservasCancelables.length}
                        onChange={handleCancelarTodasClick}
                        inputProps={{
                          'aria-label': 'check all reservas',
                        }}
                      />
                      : null} */}
                  </TableCell>
                ))}
                {/* <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={reservasACancelar.length > 0 && reservasACancelar.length < reservasCancelables.length}
                    checked={reservasACancelar.length > 0 && reservasACancelar.length === reservasCancelables.length}
                    onChange={handleCancelarTodasClick}
                    inputProps={{
                      'aria-label': 'check all reservas',
                    }}
                  />
                </TableCell> */}
              </TableRow>
            </TableHead>
            {!!rows && rows.length > 0 ?
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                  rows.slice().sort(getComparator(order, orderBy)) */}
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.cliente_id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      // onClick={(event) => openItem(event, row.id ?? row.cliente_id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          onClick={(event) => handleClick(event, row.cliente_id)}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell> */}
                      {columns.map(column => {
                        const columnValue = () => {
                          switch (column.id) {
                            case 'activo':
                              return row.activo ? 'SI' : 'NO';
                            case 'descripcionStr':
                              return <DescripcionCard {...row} />
                            case 'ubicaciones':
                              return <Ubicaciones ubicaciones={row.ubicaciones} onCheck={(ubicacion) => handleCheck(row, ubicacion)} onAsistenciaClick={(ubicacion) => handleAsistenciaClick(row, ubicacion)} hayCancelables={reservasCancelables.length > 0} />;
                            case 'fecha':
                              return moment(row.fecha).format('L');
                            default:
                              return row[column.id];
                          }
                        }
                        return <TableCell
                          // component="th"
                          id={labelId}
                          // scope={columnIndex === 0 ? "row" : ""}
                          padding={column.disablePadding ? 'none' : 'normal'}
                          align={column.numeric ? 'right' : 'left'}
                        >
                          {columnValue()}
                        </TableCell>
                      })}
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          : (loading
            ? <TableBody><TableRow><TableCell colSpan={columns.length} padding="normal" align="center"><CircularProgress /></TableCell></TableRow></TableBody>
            : <TableBody><TableRow><TableCell colSpan={columns.length} align="center"><Typography>{'No hay datos para mostrar'}</Typography></TableCell></TableRow></TableBody>)
          }
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          />
      </Paper>
    </Box>
  );
}

export default Reservas;